export enum ReviewStatuses {
  Hidden = 'hidden',
  New = 'new',
  Published = 'published'
}

export interface ReviewProps {
  _id: string;
  createdAt: string;
  patientInfo: {
    dob: string;
    name: string;
  };
  providerInfo: {
    name: string;
  };
  rating: number;
  reviewComment: string;
  status: ReviewStatuses.New | ReviewStatuses.Published | ReviewStatuses.Hidden;
}
export interface ReviewResponseProps {
  data: {
    prevReview: ReviewProps;
    review: ReviewProps;
  };
  info: {
    nextReviewId: string;
    prevReviewId: string;
  };
}

export interface ReviewsProps {
  data: ReviewProps[];
  info: {
    counter: {
      hidden: number;
      new: number;
      published: number;
      total: number;
    };
    totalCount: number;
  };
}

export interface ReviewsQueryParams {
  filter?: string;
  limit?: number;
  localTz?: string;
  pageNo?: number;
  searchKey?: string;
  sortField?: string;
  sortOrder?: string;
  status?: string;
}

export const initialState: ReviewsProps = {
  data: [
    {
      _id: '',
      createdAt: '',
      patientInfo: {
        dob: '',
        name: ''
      },
      providerInfo: {
        name: ''
      },
      rating: 0,
      reviewComment: '',
      status: ReviewStatuses.New
    }
  ],
  info: {
    counter: {
      hidden: 0,
      new: 0,
      published: 0,
      total: 0
    },
    totalCount: 0
  }
};
